import { render, staticRenderFns } from "./ModalNewCustomer.vue?vue&type=template&id=159da448"
import script from "./ModalNewCustomer.vue?vue&type=script&lang=js"
export * from "./ModalNewCustomer.vue?vue&type=script&lang=js"
import style0 from "./ModalNewCustomer.vue?vue&type=style&index=0&id=159da448&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('159da448')) {
      api.createRecord('159da448', component.options)
    } else {
      api.reload('159da448', component.options)
    }
    module.hot.accept("./ModalNewCustomer.vue?vue&type=template&id=159da448", function () {
      api.rerender('159da448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/ModalNewCustomer.vue"
export default component.exports